module.exports = __webpack_public_path__ + "_/skins/Green-Dimension-V2-4308a2fc648033bf5fe7c4d56a5c8823.wsz";